import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreate = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 96 96",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M66 42H54V30a6 6 0 00-12 0v12H30a6 6 0 000 12h12v12a6 6 0 0012 0V54h12a6 6 0 000-12z" }), /* @__PURE__ */ _jsx("path", { d: "M48 0a48 48 0 1048 48A48.051 48.051 0 0048 0zm0 84a36 36 0 1136-36 36.04 36.04 0 01-36 36z" })]
});
export default SvgCreate;
